import { useState, useEffect } from 'react';

const useForm = (initialValues, callback, validate, stepIndex, translations, fetching) => {
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      callback();
    }
    // eslint-disable-next-line
  }, [errors, isSubmitting]);

  const handleSubmit = event => {
    if (event) event.preventDefault();
    // Only validate if the validate function is used
    if (validate) {
      setErrors(validate(values, stepIndex, translations, fetching));
    }
    setIsSubmitting(true);
  };

  const handleChange = event => {
    event.persist();
    if (event.target.name === 'landskap') {
      const min = event.target.options[event.target.selectedIndex].dataset.minorder;
      setValues({
        ...values, [event.target.name]: event.target.value, min_order: min,
      });
    }
    if (event.target.name === 'kvm') {
      const maxOrder = 4000;
      // const kvmInput = Math.max(values.min_order, Math.min(maxOrder, Number(event.target.value)));
      setValues({
        ...values, [event.target.name]: event.target.value,
      });
      if (Number(event.target.value) < Number(values.min_order)) {
        setErrors({
          ...errors, [event.target.name]: 'Minimum that can be ordered is '+values.min_order,
        })
      } else if (Number(event.target.value) > Number(maxOrder)) {
        setErrors({
          ...errors, [event.target.name]: 'Maximum that can be ordered is '+maxOrder,
        })
      } else {
        setErrors({
          ...errors, [event.target.name]: false,
        })
      }
    }
    if (event.target.name === 'antal_plan') {
      setValues({
        ...values, [event.target.name]: event.target.value, plan_tillagg: Number(event.target.options[event.target.selectedIndex].dataset.plantillagg),
      });
    }
    if (event.target.name === 'lutning') {
      setValues({
        ...values, [event.target.name]: event.target.value, lutnings_tillagg: Number(event.target.dataset.lutningstillagg),
      });
    }
    if (event.target.name === 'farg') {
      setValues({
        ...values, [event.target.name]: event.target.value, farg_tillagg: Number(event.target.options[event.target.selectedIndex].dataset.fargtillagg),
      });
    }
    if (event.target.name === 'tegelpanna_byte') {
      setValues({
        ...values, [event.target.name]: event.target.checked, tegelpanna_pris: event.target.checked ? Number(event.target.value) : 0, tegelpanna_antal: !event.target.checked && '',
      });
    }
    if (event.target.name === 'tegelpanna_antal') {
      setValues({
        ...values, [event.target.name]: Number(event.target.value),
      });
    }
    if (event.target.name === 'tegelpanna_lager') {
      setValues({
        ...values, [event.target.name]: event.target.checked, tegelpanna_tillagg: event.target.checked ? Number(event.target.value) : 0,
      });
    }
    if (event.target.name === 'undertak') {
      setValues({
        ...values, [event.target.name]: event.target.checked,
      });
    }
    if (event.target.name === 'namn' || event.target.name === 'epost' || event.target.name === 'adress' || event.target.name === 'ort' || event.target.name === 'telefon' || event.target.name === 'postnr') {
      setValues({
        ...values, [event.target.name]: event.target.value,
      });
    }
    if (event.target.name === 'terms' || event.target.name === 'gdpr') {
      setValues({
        ...values, [event.target.name]: event.target.checked,
      });
    }
  };

  const handleChecked = event => {
    event.persist();
    setValues({ ...values, [event.target.name]: event.target.checked });
  };

  const resetState = () => {
    setValues({ ...initialValues });
  };

  return {
    handleChange,
    handleChecked,
    handleSubmit,
    values,
    setValues,
    errors,
    resetState,
  };
};

export default useForm;
